import 'bootstrap';

function handleImageCaptionToggleEvents(): void {
  const images = document.querySelectorAll<HTMLElement>('.image-inner-caption-toggle');

  images.forEach((image) => {
    const imageCaptionText = image.querySelector<HTMLElement>('.image-inner-caption-text');
    if (imageCaptionText) {
      image.addEventListener('focus', () => {
        showCaptionText(imageCaptionText);
      });
      image.addEventListener('blur', () => {
        hideCaptionText(imageCaptionText);
      });
      image.addEventListener('mouseenter', () => {
        showCaptionText(imageCaptionText);
      });
      image.addEventListener('mouseleave', () => {
        hideCaptionText(imageCaptionText);
      });
    }
  });
}

function showCaptionText(captionText: HTMLElement): void {
  captionText.classList.add('show');
  captionText.style.maxHeight = `${captionText.closest('.image-inner')?.clientHeight}px` || 'none';
}

function hideCaptionText(captionText: HTMLElement): void {
  captionText.classList.remove('show');
  captionText.style.maxHeight = '0px';
}

document.addEventListener('DOMContentLoaded', () => {
  handleImageCaptionToggleEvents();
});
